import { HisSearch, HisSearchCriteria } from './search/his-search';

/**
 * request for search results
 */
export class HisSearchRequest {
    search: HisSearch;
    offset: number;
    limit: number;

    sortCriteria: HisSortCriteria[] = [];
    tableFilter?: HisSearchCriteria[];

    constructor( search: HisSearch, offset?: number, limit?: number, sortCriteria?: HisSortCriteria[], tableFilter?: HisSearchCriteria[] ) {
        this.search = search;

        if ( offset ) {
            this.offset = offset;
            this.limit = limit;
        }

        if(sortCriteria) {
            this.sortCriteria = sortCriteria;
        }

        if ( tableFilter ) {
            this.tableFilter = tableFilter;
        }
    }
}

export class HisSortCriteria {
    field: string;
    ascending = true;

    constructor(field: string, ascending: boolean) {
        this.field = field;
        this.ascending = ascending;
    }

}
